import { put, call, takeLatest } from 'redux-saga/effects'

import { initialize } from 'redux-form'

import { getLedgerFilters as getLedgerFiltersApi } from 'Service/Api'

import * as LedgerFilterTypes from 'Redux/Types/LedgerFilterTypes'
import * as LedgerFilterActions from 'Redux/Actions/LedgerFilterActions'

function* getLedgerFilters(payload) {
  try {
    const { data } = yield call(getLedgerFiltersApi, payload)
    yield put(LedgerFilterActions.getLedgerFiltersSucceeded(data))
  } catch (err) {
    yield put(LedgerFilterActions.getLedgerFiltersFailed(err))
  }
}

function* resetFilters(payload) {
  const { form, initialValues } = payload
  yield put(initialize(form, initialValues))
}

export default function* ledgerFilterSaga() {
  yield takeLatest(LedgerFilterTypes.RESET_LEDGER_FILTERS, resetFilters)
  yield takeLatest(LedgerFilterTypes.GET_LEDGER_FILTERS, getLedgerFilters)
}
